import { useEffect } from 'react';

function vehicleFitmentLabel(vehiclePath = {}) {
  const parts = [
    vehiclePath.make,
    vehiclePath.model,
    vehiclePath.generation || vehiclePath.year,
    vehiclePath.fuelType && vehiclePath.fuelType !== 'ALL' ? vehiclePath.fuelType : null,
  ];
  return parts.filter(Boolean).join(' / ');
}

function setMeta(name, content, { property = false } = {}) {
  if (!content) return;
  const attr = property ? 'property' : 'name';
  let el = document.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

export default function CatalogNodeSeo({ page, catalogNodeId }) {
  useEffect(() => {
    if (!page?.partCategory) return;

    const fitment = vehicleFitmentLabel(page.vehiclePath);
    const sellerCount = page.activeListingCount || 0;
    const title = `${page.partCategory}${fitment ? ` for ${fitment}` : ''} | Sparepe`;
    const description = `Compare ${sellerCount} seller${sellerCount === 1 ? '' : 's'} for ${page.partCategory}${fitment ? ` (${fitment})` : ''}. Ranked by price, rating, and dispatch speed.`;

    document.title = title;
    setMeta('description', description);
    setMeta('og:title', title, { property: true });
    setMeta('og:description', description, { property: true });
    setMeta('og:type', 'product', { property: true });
    if (catalogNodeId) {
      const url = `${window.location.origin}/catalog/node/${catalogNodeId}`;
      setMeta('og:url', url, { property: true });

      let canonical = document.querySelector('link[rel="canonical"]');
      if (!canonical) {
        canonical = document.createElement('link');
        canonical.setAttribute('rel', 'canonical');
        document.head.appendChild(canonical);
      }
      canonical.setAttribute('href', url);
    }

    return () => {
      document.title = 'Sparepe Fit.Fix.Go';
    };
  }, [page, catalogNodeId]);

  return null;
}
